import React, { useState, useEffect } from 'react';
import { 
  Button, Dialog, DialogActions, DialogContent, DialogTitle 
} from '@mui/material';
import { updateSettings } from '../api';
import ServerForm from './ServerForm';
import { DEFAULT_SERVER_SETTINGS } from '../constants';

export default function EditServerDialog({ open, onClose, server, onUpdate }) {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    server_settings: {},
    docker_settings: { ports: {} }
  });

  useEffect(() => {
    if (server) {
      // Merge server settings with default settings to ensure all fields are populated
      const mergedSettings = { ...DEFAULT_SERVER_SETTINGS, ...server.server_settings };
      
      // Filter out null/undefined values just in case, but keep empty strings if they are valid values (though defaults usually aren't empty)
      // Actually, we want to show the current values. If a value is missing in server.server_settings, it means it's using the default.
      // So merging with DEFAULT_SERVER_SETTINGS is the correct way to show what the server is currently running with (assuming defaults match).

      setFormData({
        name: server.name,
        server_settings: mergedSettings,
        docker_settings: { ...server.docker_settings }
      });
    }
  }, [server]);

  const handleChange = (section, field, value) => {
    setFormData({
      ...formData,
      [section]: { ...formData[section], [field]: value }
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      // Filter out default values before sending to backend to keep DB clean
      const cleanSettings = {};
      Object.entries(formData.server_settings).forEach(([key, value]) => {
        if (value !== DEFAULT_SERVER_SETTINGS[key] && value !== "" && value !== null) {
          cleanSettings[key] = value;
        }
      });

      const cleanData = {
          ...formData,
          server_settings: cleanSettings
      };

      await updateSettings(server.name, cleanData);
      onUpdate();
      onClose();
    } catch (error) {
      alert('Failed to update server: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  if (!server) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Edit Server Settings</DialogTitle>
      <DialogContent>
        <ServerForm data={formData} onChange={handleChange} isEdit={true} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}>
          {loading ? 'Saving...' : 'Save & Restart'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}